import React, { lazy } from "react";
const AssignmentsPage = lazy(() => import("./pages/AssignmentsPage"));
export const assignmentRoutes = [
  { path: "/assignments", element: <AssignmentsPage /> },
];
